export type PageStripeType = {
  currentPage: string | undefined
  previousPage: string | undefined
  nextPage: string | undefined
}

export enum ApiFinanceType {
  BOX = "BOX",
  USER = "USER",
}

export enum TransactionStatus {
  SUCCEEDED = "SUCCEEDED",
  PENDING = "PENDING",
  FAILED = "FAILED",
  DISPUTED = "DISPUTED",
  REFUNDED = "REFUNDED",
}

export enum PayoutTransferStatus {
  PENDING = "PENDING",
  IN_TRANSIT = "IN_TRANSIT",
  PAID = "PAID",
  CANCELED = "CANCELED",
  FAILED = "FAILED",
}

export enum PaymentMethodType {
  ACH_CREDIT_TRANSFER = "ACH_CREDIT_TRANSFER",
  ACH_DEBIT = "ACH_DEBIT",
  ACSS_DEBIT = "ACSS_DEBIT",
  AFFIRM = "AFFIRM",
  AFTERPAY_CLEARPAY = "AFTERPAY_CLEARPAY",
  ALIPAY = "ALIPAY",
  ALMA = "ALMA",
  AMAZON_PAY = "AMAZON_PAY",
  AU_BECS_DEBIT = "AU_BECS_DEBIT",
  BACS_DEBIT = "BACS_DEBIT",
  BANCONTACT = "BANCONTACT",
  BLIK = "BLIK",
  BOLETO = "BOLETO",
  CARD = "CARD",
  CARD_PRESENT = "CARD_PRESENT",
  CASHAPP = "CASHAPP",
  CUSTOMER_BALANCE = "CUSTOMER_BALANCE",
  EPS = "EPS",
  FPX = "FPX",
  GIROPAY = "GIROPAY",
  GRABPAY = "GRABPAY",
  IDEAL = "IDEAL",
  INTERAC_PRESENT = "INTERAC_PRESENT",
  KAKAO_PAY = "KAKAO_PAY",
  KLARNA = "KLARNA",
  KONBINI = "KONBINI",
  KR_CARD = "KR_CARD",
  LINK = "LINK",
  MOBILEPAY = "MOBILEPAY",
  MULTIBANCO = "MULTIBANCO",
  NAVER_PAY = "NAVER_PAY",
  OXXO = "OXXO",
  P24 = "P24",
  PAYCO = "PAYCO",
  PAYNOW = "PAYNOW",
  PAYPAL = "PAYPAL",
  PIX = "PIX",
  PROMPTPAY = "PROMPTPAY",
  REVOLUT_PAY = "REVOLUT_PAY",
  SAMSUNG_PAY = "SAMSUNG_PAY",
  SEPA_CREDIT_TRANSFER = "SEPA_CREDIT_TRANSFER",
  SEPA_DEBIT = "SEPA_DEBIT",
  SOFORT = "SOFORT",
  STRIPE_ACCOUNT = "STRIPE_ACCOUNT",
  SWISH = "SWISH",
  TWINT = "TWINT",
  US_BANK_ACCOUNT = "US_BANK_ACCOUNT",
  WECHAT = "WECHAT",
  WECHAT_PAY = "WECHAT_PAY",
  ZIP = "ZIP",
  UNKNOWN = "UNKNOWN",
}

export enum DisputeStatus {
  LOST = "LOST",
  NEEDS_RESPONSE = "NEEDS_RESPONSE",
  UNDER_REVIEW = "UNDER_REVIEW",
  WARNING_CLOSED = "WARNING_CLOSED",
  WARNING_NEEDS_RESPONSE = "WARNING_NEEDS_RESPONSE",
  WARNING_UNDER_REVIEW = "WARNING_UNDER_REVIEW",
  WON = "WON",
}

export enum DisputeReason {
  BANK_CANNOT_PROCESS = "BANK_CANNOT_PROCESS",
  CHECK_RETURNED = "CHECK_RETURNED",
  CREDIT_NOT_PROCESSED = "CREDIT_NOT_PROCESSED",
  CUSTOMER_INITIATED = "CUSTOMER_INITIATED",
  DEBIT_NOT_AUTHORIZED = "DEBIT_NOT_AUTHORIZED",
  DUPLICATE = "DUPLICATE",
  FRAUDULENT = "FRAUDULENT",
  GENERAL = "GENERAL",
  INCORRECT_ACCOUNT_DETAILS = "INCORRECT_ACCOUNT_DETAILS",
  INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
  PRODUCT_NOT_RECEIVED = "PRODUCT_NOT_RECEIVED",
  PRODUCT_UNACCEPTABLE = "PRODUCT_UNACCEPTABLE",
  SUBSCRIPTION_CANCELED = "SUBSCRIPTION_CANCELED",
  UNRECOGNIZED = "UNRECOGNIZED",
}
